import has from 'lodash/has';

/**
 * @typedef {'key'|'name'|'pitchResult'|'pitchCall'|'plateAppearanceResult'} PitchResultCombinedEnumItemKey
 * @typedef {Record<PitchResultCombinedEnumItemKey, string> PitchResultCombinedEnumItem}
 */

/**
 * @param {string} origKey
 * @param {PitchResultCombinedEnumItem} enumItem
 * @param {Record<string, string> & {default: string}} mapper
 * @returns {string} color
 */
function getColorForPitchResultCombined(
  origKey, enumItem, mapper
) {
  const { key, pitchCall, test } = enumItem;

  if (has(mapper, key)) {
    return mapper[key];
  }

  if (has(mapper, pitchCall)) {
    return mapper[pitchCall];
  }

  return mapper.default;
};

export default getColorForPitchResultCombined;
